import axios  from "axios"

const apiUrl = localStorage.getItem('CF_BASE_URL')?.replace("/admin", "") || process.env.VUE_APP_BASE_URL?.replace("/admin", "");

export default {

    // banks
    async getBanks(params){
        try{
            const {data} = await axios.get(`${apiUrl}/finance/bank`, {params})
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },

    async getBanksById(id){
        try{
            const {data} = await axios.get(`${apiUrl}/finance/bank/${id}`)
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },

    async createBank(payload){
        try{
            const {data} = await axios.post(`${apiUrl}/finance/bank`, payload)
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },

    async updateBank(id, payload){
        try{
            const {data} = await axios.put(`${apiUrl}/finance/bank/${id}`, payload)
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },

    async deleteBank(id){
        try{
            const {data} = await axios.delete(`${apiUrl}/finance/bank/${id}`)
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },
    // loan program 
    async getLoanPrograms(params){
        try{
            const {data} = await axios.get(`${apiUrl}/finance/loan-program`, {params})
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },
     
    async getLoanProgramById(id){
        try{
            const {data} = await axios.get(`${apiUrl}/finance/loan-program/${id}`)
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },

    async createLoanProgram(payload, params = {}){
        try{
            let url = `${apiUrl}/finance/loan-program`;
            if (params.fileFields) {
                const encoded = String(params.fileFields)
                    .split(',')
                    .map(s => encodeURIComponent(s.trim()))
                    .join(',');
                url += `?fileFields=${encoded}`;
            }
            const {data} = await axios.post(url, payload, {
                headers: {
                    'Accept': 'application/json',
                },
            })
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },

    async updateLoanProgram(id, payload, params = {}){
        try{
            let url = `${apiUrl}/finance/loan-program/${id}`;
            if (params.fileFields) {
                const encoded = String(params.fileFields)
                    .split(',')
                    .map(s => encodeURIComponent(s.trim()))
                    .join(',');
                url += `?fileFields=${encoded}`;
            }
            const {data} = await axios.put(url, payload, {
                headers: {
                    'Accept': 'application/json',
                },
            })
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },
}